import React from 'react';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { Section } from 'common';
import strings from 'strings';
import FPLink from 'UI/components/atoms/FPLink';
import { filterValidItems, isTruthyValue } from 'utils';

import { DescriptionText } from '../../styles';

export const References = ({ references = [] }) => {
  const validReferences = filterValidItems(references);
  if (validReferences.length === 0) return null;

  return (
    <Section title={strings.candidates.profile.resumeTab.sections.references}>
      <List disablePadding>
        {validReferences.map(reference => {
          const {
            company,
            description,
            email,
            full_name: fullName,
            phone_number: phoneNumber,
            position
          } = reference;

          const emailToRender = email && (
            <FPLink href={`mailto:${email}`} linkProps={{ type: 'external', url: email }} />
          );

          const phoneToRender = phoneNumber && (
            <FPLink
              linkProps={{
                type: 'ringCentral',
                url: phoneNumber,
                customLinkProps: { formatPhone: true }
              }}
            />
          );

          return (
            <ListItem key={fullName} disableGutters>
              <ListItemText
                primary={
                  <>
                    {isTruthyValue(fullName) && (
                      <Typography>
                        <b>{fullName}</b>
                      </Typography>
                    )}

                    {(isTruthyValue(position) || isTruthyValue(company)) && (
                      <Typography>
                        {position} / {company}
                      </Typography>
                    )}

                    {(isTruthyValue(emailToRender) || isTruthyValue(phoneToRender)) && (
                      <Box display="flex" alignItems="center">
                        <Typography paragraph={false} color="textSecondary">
                          {emailToRender}
                        </Typography>
                        &nbsp;&#183;&nbsp;
                        <Typography paragraph={false} color="textSecondary">
                          {phoneToRender}
                        </Typography>
                      </Box>
                    )}

                    {isTruthyValue(description) && (
                      <DescriptionText component="pre" variant="body2">
                        {description}
                      </DescriptionText>
                    )}
                  </>
                }
              />
            </ListItem>
          );
        })}
      </List>
    </Section>
  );
};
